import { ProfilePanel } from "@/components/organisms";

export const Profile = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <ProfilePanel />
    </div>
  );
};
